import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import NoImagePlaceholder from "../../assets/ProfilePlaceHolder.png";
import LoadingSpinner from "../../components/LoadingSpinner";
import ShowAccessModal from "./modals/ShowAccessModal";
import { useNavigate } from "react-router-dom";

export default function ClassTokens() {
  const [isLoading, setIsLoading] = useState(true);
  const { user, dispatch } = useAuthContext();
  const [selecetedToken, setSelectedToken] = useState(null);
  const [tokenAccessModal, setTokenAccessModal] = useState(false);
  const [tokens, setTokens] = useState([]);
  console.log(tokens)
  const navi = useNavigate();

  const cancelModal = () => {
    setTokenAccessModal(false);
  };
  const fetchData = async () => {
    try {
      setIsLoading(true);

      const tokenReponse = await axios.get(
        `${ApiConnectionString}/api/Tokens?AppUserId=${user.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setTokens(tokenReponse.data);

      setIsLoading(false);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);


  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div>
        <div className="lightBlueBanner mt-2">
          <p className="text-white p-2 fw-bold ">List of classes</p>
        </div>
        <div className="">
    {tokens
  .filter((toke) => toke.tokenAmount > 0)
  .map((toke) => (
    <div
      onClick={() => {
        setSelectedToken(toke);
        setTokenAccessModal(true);
      }}
      key={toke.id}
      className="your-classes-container p-3 my-1 rounded shadow"
    >
      <div className="row align-items-center">
        <p className="my-0 p-0 fw-bold">{toke.viewProduct.name}</p>
        <div className="col-6 text-center">
          <div className="circle-crop">
            <img
              src={
                toke.viewClubs.image
                  ? `${ApiConnectionString}/api/ClubProfileImage/${toke.viewClubs.id}`
                  : NoImagePlaceholder
              }
              alt="Club Image"
              className="mt-0"
            />
          </div>
        </div>

        <div className="col">
          <div className="d-flex">
            <div className="m-4">
              <p className="red-text mb-0">Club</p>
              <p className="fw-bold">{toke.viewClubs.name}</p>
            </div>

            <div className="m-4">
              <p className="red-text mb-0">Classes Available</p>
              <p className="fw-bold">{toke.tokenAmount}</p>
            </div>
          </div>
          <p className="mx-4 text-muted">
            {toke.viewProduct.totalAccess
              ? "This allows for access to all classes at this club."
              : "This allows for access to limited classes at this club."}
          </p>
        </div>
      </div>
    </div>
))}
        </div>
        {tokenAccessModal && (
          <ShowAccessModal
            cancelModal={cancelModal}
            selecetedToken={selecetedToken}
          />
        )}
      </div>
    );
  }
}
